import {Line} from "@models/line.model";
import {RiskClass} from "@app/strain/config/risk-classes/models/risk-class.model";
import {PartNumber} from "@models/partNumber.model";
import {Equipment} from "@models/equipment.model";
import {ProcessType} from "@models/process-type.model";
import {PagedResponse} from "@models/response.model";
import {StrainStatus} from "@app/strain/registry/models/strain-status.model";
import {ToolService} from "@services/tool.service";
import {StrainMeasurement} from "@app/strain/common/models/strain-registry-measurement.model";
import {RegistryItemSampleBoard} from "@app/strain/materials/models/registry-item-sample-board";
import {StrainRegistryCode} from "./strain-registry-code.model";

export class StrainRegistryEntry {

    public id: number;
    public isCustom: boolean;
    public parentId: number;
    public oldEntry: string;
    public partNumber: PartNumber;
    public line: Line;
    public equipment: Equipment;
    public process: ProcessType;
    public riskClass: RiskClass;
    public toolInfo: string;
    public codes: StrainRegistryCode[];
    public limitAcceptedByClient: number;
    public sampleBoards: RegistryItemSampleBoard[];
    public status: StrainStatus;
    public cancelReason: string;
    public lastMeasurementDate: string;
    public nextMeasurementDate: string;
    public tools: any[];
    public measurements: PagedResponse<StrainMeasurement>;
    public isStableProcess: boolean;
    public isEndOfLife: boolean;
    public endOfLifeReason: string;
    public isAfterMarket: boolean;
    public hasTools: boolean;
    public name: string;
    public isStockSufficient: boolean;
    public equipmentType: string;

    constructor(registryEntry: any = {}) {
        this.id = registryEntry.id;
        this.isCustom = registryEntry.isCustom;
        this.oldEntry = registryEntry.oldEntry;
        this.parentId = registryEntry.parentId;
        this.partNumber = registryEntry.partNumber ? new PartNumber(registryEntry.partNumber) : null;
        this.line = registryEntry.line ? new Line(registryEntry.line) : null;
        this.equipment = registryEntry.equipment ? new Equipment(registryEntry.equipment) : null;
        this.process = registryEntry.process ? new ProcessType(registryEntry.process) : null;
        this.riskClass = registryEntry.riskClass ? new RiskClass(registryEntry.riskClass) : null;
        this.toolInfo = registryEntry.toolInfo;
        this.codes = registryEntry.codes ? registryEntry.codes.map(item => new StrainRegistryCode(item)) : [];
        this.limitAcceptedByClient = registryEntry.limitAcceptedByClient;
        this.sampleBoards = registryEntry?.sampleBoards ?
            registryEntry.sampleBoards.map((item: any) => new RegistryItemSampleBoard(item)) : [];
        this.status = registryEntry.status;
        this.cancelReason = registryEntry.cancelReason;
        this.lastMeasurementDate = registryEntry.lastMeasurementDate ? registryEntry.lastMeasurementDate : 'N/A'
        this.nextMeasurementDate = registryEntry.nextMeasurementDate ? registryEntry.nextMeasurementDate : 'N/A';
        this.tools = registryEntry.tools ? ToolService.mapToolsAndSets(registryEntry.tools) : [];
        this.measurements = registryEntry.measurements ? registryEntry.measurements : [];
        this.isStableProcess = registryEntry.isStableProcess;
        this.isEndOfLife = registryEntry.isEndOfLife;
        this.isAfterMarket = registryEntry.isAfterMarket;
        this.hasTools = registryEntry.hasTools;
        this.name = registryEntry.name;
        this.endOfLifeReason = registryEntry.endOfLifeReason;
        this.isStockSufficient = registryEntry.isStockSufficient;
        this.equipmentType = registryEntry.equipmentType;
    }
}
